import { AccountSwitcherOptionGroupMobile } from "./AccountSwitcherOptionGroup";
import { type AccountSwitcherUser, type UserDetails } from "../../Shared/AccountSwitcher/types";

interface AccountSwitcherMenuWorkplaceMobileProps {
  workplaceDetails: UserDetails;
  onUserClicked: (user: AccountSwitcherUser) => void;
}

export function AccountSwitcherMenuWorkplaceMobile(props: AccountSwitcherMenuWorkplaceMobileProps) {
  const { workplaceDetails, onUserClicked } = props;

  return (
    <AccountSwitcherOptionGroupMobile
      userDetails={workplaceDetails}
      onUserClicked={onUserClicked}
      loadMoreLabel="Load more workplaces"
    />
  );
}
